import KeyboardArrowRightIcon from "../assets/icons/redArrowLeftIcon.svg";
import ArrowOutwardIcon from "../assets/icons/ArrowOutwardIcon.svg";
import personIcon from "../assets/icons/person.svg";
import folderIcon from "../assets/icons/folder.svg";
import downloadStatementIcon from "../assets/icons/download-statement.svg";
import worstIcon from "../assets/icons/Worst.svg";
import badIcon from "../assets/icons/Bad.svg";
import fineIcon from "../assets/icons/Fine.svg";
import goodIcon from "../assets/icons/Good.svg";
import bestIcon from "../assets/icons/Best.svg";
import worstClickIcon from "../assets/icons/Worst-enable.svg";
import badClickIcon from "../assets/icons/Bad-enable.svg";
import fineClickIcon from "../assets/icons/Fine-enable.svg";
import goodClickIcon from "../assets/icons/Good-enable.svg";
import bestClickIcon from "../assets/icons/Best-enable.svg";
import emailIcon from "../assets/icons/email red.svg";
import whatsappIcon from "../assets/icons/whatsapp.svg";
import CalendarIcon from "../assets/icons/calendar-today-icon.svg";
import PencilIcon from "../assets/icons/pencil.svg";
import TransactIcon from "../assets/icons/transact-icon.svg";
import AccountStatementIcon from "../assets/icons/accountStatementIcon.svg";
import CapitalGainIcon from "../assets/icons/capital-gain-icon.svg";
import RedeemIcon from "../assets/icons/redeem-icon.svg";
import SwitchIcon from "../assets/icons/switch-icon.svg";
import SwpIcon from "../assets/icons/swp-icon.svg";
import StpIcon from "../assets/icons/stp-icon.svg";
import ViewBankIcon from "../assets/icons/viewbank-icon.svg";
import RegisterOTMIcon from "../assets/icons/register-otm-icon.svg";
import pauseCancelIcon from "../assets/icons/pause-cancel-icon.svg";
import addModifyNomineeIcon from "../assets/icons/add-modify-nominee-icon.svg";
import changeContactIcon from "../assets/icons/change-contact-icon.svg";
import whatsappOptInIcon from "../assets/icons/whatsapp-opt-in-icon.svg";
import { T_CreateCaseRequest } from "../features/Feature_LifeInsurance/LifeInsurance_Types";
import { T_CreateCaseAPIRequest } from "../features/Feature_Homeloan/Homeloan_Types";
import { T_OnUserLoginCleverTapStatic } from "../globalTypes/GlobalTypes";
import { T_CmsRateContentVariables } from "../features/Features_Cms/CmsGlobal.Types";

export const ABCD_SUPERAPP_SOURCE_NAME = "ABCD SUPER APP";
export const ABCD_SUPERAPP_URL = process.env.REACT_APP_ABCD_SUPERAPP_URL;
export const tabViewPoint = 768;
export const middleViewPoint = 900;
export const REACT_APP_URL = process.env.REACT_APP_URL;
export const iOSType = "iOS";
export const androidType = "Android";

export const ABCD_PLAYSTORE_URL = process.env.REACT_APP_ABCD_PLAYSTORE_URL;
export const ABCD_APPSTORE_URL = process.env.REACT_APP_ABCD_APPSTORE_URL;

export const ABC_SERVICE_PLAYSTORE_URL =
  process.env.REACT_APP_ABC_SERVICE_PLAYSTORE_URL;

export const ABC_SERVICE_APPSTORE_URL =
  process.env.REACT_APP_ABC_SERVICE_APPSTORE_URL;

export const ABCD_APPSTORE_SCHEME = "abcd://adityabirlacapitaldigital.com";
export const ABCD_SUPER_APP_APPSTORE_URL =
  "https://apps.apple.com/in/app/abcd-aditya-birla-capital/id6477909524";
export const ABCD_SUPER_APP_PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.adityabirlacapitaldigital.OneApp";
export const ABCD_SUPER_APP_SCHEME =
  "abcd://adityabirlacapitaldigital.com?mobileNumber=";

export const MF_API_BASE_URL = process.env.REACT_APP_MF_API_BASE_URL;
export const TRADE_US_URL =
  "https://apps.apple.com/in/app/abcd-aditya-birla-capital/id6477909524?mt=8";
export const ONE_LOGIN_DASHBOARD =
  "https://onelogin.adityabirlacapital.com/my-dashboard";
export const ABCD_SUPER_APP_PACKAGE_NAME = "com.adityabirlacapital.abconeapp";
export const ABCD_SUPER_APP_BUNDLE_ID = "123456789"; //need to replace with original value

export const MF_LOB_ID = "ABSLAMC";
export const STOCK_LOB_ID = "ABML";
export const LOANS_LOB_ID = "ABFL";

export const UI_SESSION_TIMEOUT = 5 * 60 * 1000;
export const UI_SESSION_TIMEOUT_PROMT = 0.5 * 60 * 1000;
export const ABCDLobCode = "25";
export const LiLobCode = "ABSLI";
export const HiLobCode = "ABHI";
export const HlLobCode = "ABHFL";
export const MfLobCode = "ABSLAMC";
export const StockLobCode = "ABML";
export const PersonalLoansLobCode = "ABFL";
export const ABCDHoldingsLobCode = "ABCD";
export const OneLoginLobCode = "11";
export const OneLoginRedirectUrl = "https://uatonelogin.abcscuat.com/Interface";
export const HiDestinationLobId = "06";
export const LiDestinationLobId = "02";
export const MfDestinationLobId = "01";
export const SsDestinationLobId = "24";
export const LoansDestinationLobId = "03";
export const HomeLoansDestinationLobId = "04";
export const Cs_App_Lob_Id = "26";
export const Abcd_Super_App_Lob_Id = "25";
export const onlyAlphaNumericRegex = /^[A-Za-z0-9]+$/;
export const ALPHA_NUMERIC_WITH_SPACE_REGEX = /[^a-zA-Z0-9 ]/g;
export const folioApiReqBodyUserId = "MF_Tan";
export const folioApiReqBodyPSW = "VUFUX1Rhbg==";

export const REGISTER_BIO_METRIC = "REGISTER_BIO_METRIC";
export const OneLoginProdUrl = "https://onelogin.adityabirlacapital.com/login";

export const ABC_APP_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.adityabirlacapital.abconeapp";
export const ABC_APP_APP_STORE_URL =
  "https://apps.apple.com/us/app/aditya-birla-capital/id1573921028";
export const ABC_ONE_LOGIN_URL =
  "https://onelogin.adityabirlacapital.com/login";

export enum InAppFeatureFuncCodes {
  LI_RE_KYC = "02REKYC",
  LI_PAN_AADHAR_LINKING = "02PASS",
  LI_DOWNLOAD_STATMENTS_DRAWER = "02MS",
  LI_DETAILS_PAGE = "01DP",
  LI_UPDATE_PAN = "02UP",
  LI_UPDATE_EMAIL = "02UPEM",
  LI_UPDATE_MOBILE_NUMBER = "02UPMONU",
  LI_WHATSAPP_OPT_IN_OUT = "02WHTS_IN_OUT",
  LI_ADD_UPDATE_BANK_ACCOUNT = "02AUBD",
  LI_UPDATE_NOMINEE = "02UPNO",
  LI_POLICY_ACCOUNT_STATEMENT = "PAC",
  LI_PREMIUM_RECEIPTS = "PR",
  LI_APP_TAX_CERTIFICATE = "TC",
  LI_ADD_UPDATE_NOMINEE = "02AUND",
  HL_AMORTIZATION_SCHEDULE = "04AS",
  IN_APP_E_NACH = "04CEN",
  HL_PROVISIONAL_INTEREST_CERTIFICATE = "04PIC",
  HL_STATEMENTS_DOCUMENTS_WELCOME_KIT = "04WKIT",
  HL_STATEMENTS_DOCUMENTS_REPAYMENT_SCHEDULE = "04SDRS",
  HL_STATEMENT_OF_ACCOUNT = "04DSA",
  HL_ACCOUNT_RELATED_SWAP_MANDATE = "04ASM",
  HL_DISBURSEMENT_REQUEST = "04DR",
  HL_INTEREST_CERTIFICATE = "04DIC",
  HL_STATEMENTS_DOCUMENTS_WELCOME_KIT_ALT = "04SDK2",
  HL_MOBILE_NUMBER_CHANGE = "04MNC",
  HL_PROFILE_RELATED = "04PR",
  HL_STATEMENTS_DOCUMENTS_BALANCE_CONFIRMATION_LETTER = "04SDBCL",
  HL_ACCOUNT_RELATED_EMI_EXCESS_RELATED = "04AER",
  HL_TDS_REFUND = "04TR",
  HL_ACCOUNT_RELATED_GST_INVOICE = "04AGI",
  HL_STATEMENTS_DOCUMENTS_INSURANCE_COPY = "04SDIC",
  HL_ACCOUNT_RELATED_EMI_DATE_CHANGE = "04AEDC",
  HL_CHANGE_EMI_TENURE = "04CET",
  HL_GST_INVOICE = "04GI",
  HL_UPDATE_EMAIL = "04UE",
  HL_IN_APP_EMI_PAYMENT = "04OEMI",
  HL_IN_APP_ADVANCE_EMI_PAYMENT = "04AEP",
  HL_CHANGE_ADDRESS = "04CA",
  HL_LIST_OF_DOCUMENTS = "04LOD",
  HL_PROCESSING_FEES_REFUND = "04PFR",
  HI_EDIT_MOBILE_NUMBER = "06CDEM",
  HI_ALTERNATE_MOBILE_NUMBER = "06CDAM",
  HI_EMAIL = "06CDM",
  HI_ADDRESS = "06CDA",
  HI_UPDATE_NOMINEE = "06ND",
  HI_EDIT_PAN = "06PDEP",
  HI_PROPOSER_NAME = "06PDPN",
  HI_DOB = "06PDDOB",
  HI_GENDER = "06PDG",
  HI_DETAIL_PAGE = "06HID",
  HI_POLICY_DOCUMENTS = "06PODC",
  HI_PREMIUMCERTIFICATE = "06PDPC",
  HI_POLICYSCHEDULE = "06PDPS",
  HI_POLICYWORDINGS = "06PDPW",
  HI_ECARD = "06PDEC",
  HI_ABHA_ID = "06QAABHAID",
  HI_CALL_DOCTOR = "06QACD",
  HI_MY_REQUEST = "06QAMR",
  HI_QUICK_ACTION_MAIN_MENU = "06QA",
  HI_POLICY_RENEWAL = "06PR",
  HI_TRACKING_CLAIM = "06TRCKCLM",
  HI_MY_CLAIM = "06MYCLM",
  HI_RAISE_CLAIM = "06RAISECLM",
  HI_UTILITIES = "06UTI",
  HI_CASHLESS_NETWORK_HOSPITAL = "06UTICNH",
  HI_BMI_CALCULATOR = "06UTIBMI",
  HI_ACTIVE_AGE_CALCULATOR = "06UTIAAC",
  HI_CONTACT_DETAILS = "06CD",
  HI_PROPOSER_DETAILS = "06PD",
  GA_INSURANCE_TAB_HOME = "DINS",
  GA_INVESTMENT_TAB_HOME = "DINV",
  GA_LOAN_TAB_HOME = "DLO",
  GA_SEARCH = "GAS",
  GA_DASHBOARD = "D",
  HL_STATEMENTS_DOCUMENTS_NO_DUES_CERTIFICATE = "04NDC",
  HL_ROI_HISTORY = "04ROIH",
  HL_RE_KYC = "04REKYC",
  HL_POST_DISBURSEMENT_DOCUMENT = "04PDD",
}

export enum DEVICE_TYPE {
  MOBILE = "150",
  WEB = "151",
  PWA_WEB = "152",
  PWA_MOBILE = "153",
  ABC_WEB_MOB_CS = "155",
}

export enum SCREEN_TYPE {
  StockScreenType = "ss_servicing",
  HFScreenType = "hfl_servicing",
  HIScreenType = "hi_servicing",
  LIScreenType = "li_servicing",
  MFScreenType = "mf_servicing",
  DashboardScreenType = "servicing_homescreen_dashboard",
  generalAppType = "ga_servicing",
  PreLoginScreenType = "servicing_pre_login",
  LoginScreenType = "servicing_login",
}

export enum UI_IDLE_STATUS {
  ACTIVE = "ACTIVE",
  IDLE = "IDLE",
  PROMPTED = "PROMPTED",
}

export const quickActionList = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "My documents",
    menuDisplayName: "My documents",
    menuIcon: folderIcon,
    parentMenuId: 1,
    menuDetails: [],
    pathname: "my-documents",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "My profile details",
    menuDisplayName: "My profile details",
    menuIcon: personIcon,
    parentMenuId: 1,
    menuDetails: [],
    pathname: "my-profile",
  },
];

export const mfStatementList = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Account statement",
    menuDisplayName: "Account statement",
    menuIcon: AccountStatementIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "account-statement",
    parent: "My Statements",
    parentKey: "my_statements",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Capital gain statement",
    menuDisplayName: "Capital gain statement",
    menuIcon: CapitalGainIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "capital-gains",
    parent: "My Statements",
    parentKey: "my_statements",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Exit load",
    menuDisplayName: "Exit load",
    menuIcon: CapitalGainIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "exit-load",
    parent: "My Statements",
    parentKey: "my_statements",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 4,
    menuName: "Transaction statement",
    menuDisplayName: "Transaction statement",
    menuIcon: TransactIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "transaction-statement",
    parent: "My Statements",
    parentKey: "my_statements",
  },
];

export const mfTransactList = [
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "Redeem",
    menuDisplayName: "Redeem",
    menuIcon: RedeemIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "redeem",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 2,
    menuName: "SWP",
    menuDisplayName: "SWP",
    menuIcon: SwpIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "swp",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 3,
    menuName: "Switch",
    menuDisplayName: "Switch",
    menuIcon: SwitchIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "switch",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 4,
    menuName: "STP",
    menuDisplayName: "STP",
    menuIcon: StpIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "stp",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 5,
    menuName: "Pause/Cancel SIP",
    menuDisplayName: "Pause/Cancel SIP",
    menuIcon: pauseCancelIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "pause-cancel",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 6,
    menuName: "View/Add Bank",
    menuDisplayName: "View/Add Bank",
    menuIcon: ViewBankIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "view-add-bank",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 7,
    menuName: "Register OTM",
    menuDisplayName: "Register OTM",
    menuIcon: RegisterOTMIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "register-otm",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 8,
    menuName: "Add/Modify Nominee",
    menuDisplayName: "Add/Modify Nominee",
    menuIcon: addModifyNomineeIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "add-modify-nominee",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 9,
    menuName: "Change Contact",
    menuDisplayName: "Change Contact",
    menuIcon: changeContactIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "change-contact",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 10,
    menuName: "WhatsApp Opt in",
    menuDisplayName: "WhatsApp Opt in",
    menuIcon: whatsappOptInIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "whatsapp-opt-in",
    parent: "Transact",
    parentKey: "transact",
  },
];

export const FooterDetailsList = {
  privacyPolicy: {
    title: "PRIVACY POLICY",
    description: `Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.`,
  },
  aboutUs: {
    title: "ABOUT US",
    description: `Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.`,
  },
  termsAndConditions: {
    title: "TERMS & CONDITIONS",
    description: `Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.`,
  },
};

export const radioListData = [
  { label: "Download Now", key: "download", preIcon: downloadStatementIcon },
  { label: "Get it on Email Id", key: "email", preIcon: emailIcon },
  { label: "Get it on Whatsapp", key: "whatsapp", preIcon: whatsappIcon },
];

export const LI_PolicyRegex = /^\d{0,9}$/;
export const HI_PolicyRegex = /^\d{2}-\d{2}-\d{7}-\d{2}$/;
export const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
export const phoneRegex = /^[6-9]\d{9}$/;
export const emailRegex = /^[^\s@]{1,64}@[^\s@]{1,255}\.[^\s@]{2,63}$/;
export const dobRegex =
  /^(0[1-9]|[12][0-9]|3[01])\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/;

export const termsAndConditionsTitle = `Terms and Conditions`;
export const privacyPolicyTitle = `Privacy Policy`;
export const aboutUsTitle = `About Us`;
export const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const policyStatusListForTaxAndPremiumReceiptPolicyBond = [
  "WAIVER",
  "PAID-UP ANNUITY/EXTENDED TERM",
  "RPU ULIP",
  "PREMIUM PAYING",
  "LAPSED",
  "DISCONTINUED-PAYOUT PENDING",
];
export const policyStatusListForPolicyAccountStatement = [
  "WAIVER",
  "PAID-UP ANNUITY/EXTENDED TERM",
  "SURRENDER PAYOUT PENDING",
  "PREMIUM PAYING",
  "PAID-UP LIFE",
];

export const policyStatusListForUpdatePAN = [
  "PREMIUM WAIVER OR PAYOR DEATH",
  "PAID-UP ANNUITY/ EXTENDED TERM-ULIP",
  "RPU ULIP",
  "PREMIUM PAYING",
  "LAPSED",
  "DISCONTINUED",
  "VESTED ANNUITY",
];

export const policyStatusListForAddUpdateNominees = [
  "PREMIUM PAYING",
  "PAID-UP LIFE",
  "ETI",
  "PAID-UP ENDOWMENT",
  "PAID-UP ANNUITY/EXTENDED TERM-ULIP",
  "PAID-UP ANNUITY/EXTENDED TERM",
  "ANNUITY",
  "TERM",
];

export const documentTypeForTaxCertificate = "Tax Certificate";
export const documentTypeForPremiumReceipt = "Premium Receipt";
export const documentTypeForPolicyAccountStatement = "Policy Account Statement";
export const agentCodeValue = `a2p9i9`;
export const dbDetailValue = `RWS`;

export const EVENT_HANDLER = {
  LOGOUT_EVENT: "Logout",
  EXTEND_SESSION_EVENT: "ExtendSession",
  GO_TO_SUPER_APP_EVENT: "GoToSuperApp",
  DOWNLOAD_DOCUMENT: "DownloadDocument",
};
export const GTAScreenType = {
  LIScreenType: "li_servicing",
  HI_ScreenType: "hi_servicing",
  HFScreenType: "hfl_servicing",
  MFScreenType: "mf_servicing",
  StockScreenType: "ss_servicing",
  DashboardScreenType: "servicing_homescreen_dashboard",
  PreLoginScreenType: "servicing_pre_login",
  LoginScreenType: "servicing_login",
};
export const EVENT_SESSION_TIMEOUT = {
  MSG: "LOG OUT DUE TO SESSION TIMEOUT",
};

export const hiEditPolicyTabItems = [
  "Proposer Details",
  "Contact details",
  "Nominee details",
];

export const hiEditPolicyProposalFrom = [
  {
    key: "PolicyOwnerName",
    title: "Proposer Name",
    icon: PencilIcon,
    type: "text",
    editLabel: "Name",
  },
  {
    key: "DateOfBirth",
    title: "DOB",
    icon: CalendarIcon,
    type: "dob",
    editLabel: "DOB",
  },
  {
    key: "pan",
    title: "PAN",
    icon: PencilIcon,
    type: "text",
    editLabel: "PAN",
  },
  {
    key: "aadhar",
    title: "Aadhar",
    icon: null,
  },
  {
    key: "Gender1",
    title: "Gender",
    icon: PencilIcon,
    editLabel: "PAN",
  },
];

export const hiEditPolicyContactForm = [
  {
    key: "Mobile",
    title: "Mobile Number",
    icon: PencilIcon,
    type: "text",
  },
  {
    key: "NomineeContactNumber",
    title: "Alternate Mobile Number",
    icon: PencilIcon,
    type: "text",
  },
  {
    key: "Email",
    title: "Email ID",
    icon: PencilIcon,
    type: "text",
  },
  {
    key: "Address",
    title: "Address",
    icon: PencilIcon,
    type: "text",
  },
];

export enum DashboardTabKeys {
  Insurance = "Insurance",
  Investment = "Investment",
  Loans = "Loans",
}

export const documentFormat = [
  { label: "Excel format", key: "excel" },
  { label: "Pdf format", key: "pdf" },
];

export const FeedbackOptions = [
  {
    label: "Worst",
    key: "worst",
    preIcon: worstIcon,
    postIcon: worstClickIcon,
  },
  { label: "Bad", key: "bad", preIcon: badIcon, postIcon: badClickIcon },
  { label: "Fine", key: "fine", preIcon: fineIcon, postIcon: fineClickIcon },
  { label: "Good", key: "good", preIcon: goodIcon, postIcon: goodClickIcon },
  { label: "Best", key: "best", preIcon: bestIcon, postIcon: bestClickIcon },
];

export const HL_IdentifierConstant = ["HL"];

export const HiNomineeRelationship = [
  {
    value: "Mother",
    label: "Mother",
  },
  {
    value: "Father",
    label: "Father",
  },
  {
    value: "Spouse",
    label: "Spouse",
  },
  {
    value: "Daughter",
    label: "Daughter",
  },
  {
    value: "Son",
    label: "Son",
  },
  {
    value: "Mother-in-law",
    label: "Mother-in-law",
  },
  {
    value: "Father-in-law",
    label: "Father-in-law",
  },
];

export const StatementType = [
  {
    value: "FinancialYear",
    label: "statementOfAccount.labels.selectFinancialYear", //Select a financial Year
  },
  {
    value: "DateRange",
    label: "statementOfAccount.labels.selectDateRange", //Select date range
  },
];

export const FinancialYearMonth = 4;

export const hlTermsAndConditions = [
  'Aditya Birla Home Finance Limited ("ABHFL") offers you the option of paying the Overdue amounts on your loan availed from ABHFL, by using the online payment facilities. The payment processed is through "Bill Desk" (Third Party). Please read these conditions of the Disclaimer carefully. By using the online payment facility, you agree to be bound by these terms contained herein.',
  "For making online payment, you will access a third party site. ABHFL does not in any way warrant the accuracy or completeness of the information, materials, services or the reliability of any service, advice, opinion, statement or other information displayed or distributed through such third party site. Customer may access this site solely for purposes of repayment of your Loan and you understand and acknowledge that availing of any services offered on the site or your reliance on any opinion, advice, statement, memorandum, or information available on the site shall be at your sole risk and discretion.",
  " Aditya Birla Home Finance Ltd. and its affiliates, subsidiaries, employees, officers, directors and agents, expressly disclaim any liability for any deficiency in the services of the Payment Gateway Provider. Neither Aditya Birla Home Finance Ltd. nor any of its affiliates nor their directors, officers and employees will be liable to or have any responsibility of any kind for any loss that you incur arising out of any deficiency in the services of the Payment Gateway Provider to whom the site belongs, failure or disruption of the site of Payment Gateway Provider, or resulting from the act or omission of any other party involved in making this site or the data contained therein available to you, or from any other cause relating to your access to, inability to access, or use of the site or these materials.",
  "ABHFL may change the terms of this disclaimer, at any time and without notice. It is recommended that you review the terms of this disclaimer, periodically for changes. ABHFL shall not be held responsible for all or any actions that may subsequently result in any loss, damage and or liability on account of such change in the information on this website.",
  "I hereby confirm that I am the borrower and declare that the overdue amount paid is being paid from the income earned from legitimate funds and from a bank account/credit card which belongs to me. I understand and agree that this is a regulatory requirement.",
  "I hereby confirm that I have read and agree to abide by the conditions of the Disclaimer for using the online payment facility.",
];

export const PaymentStatusList = ["SUCCESS", "FAILURE", "PENDING"];

export const LiBaseCaseCreateReqBody = {
  ONBEHALFOF: "Customer",
  ADVISORCODE: "",
  CUSTOMERID: "",
  POLICYNO: "",
  EMAILID: "",
  FIRSTNAME: "",
  LASTNAME: "",
  MOBILENO: "",
  SMSSHORTCODE: "",
  REMARKS: "",
  CATEGORY: "",
  FLSCASE: "",
  CASETYPE: "",
  CASESUBTYPE: "",
  CASESUBSUBTYPE: "",
  SOURCE: "ABC_Servicing_App",
  FTR: "",
  UDP1: "",
  UDP2: "",
  UDP3: "",
  UDP4: "",
  UDP5: "",
  ClientIPAddress: "",
  VoucherNo: "",
  VoucherDate: "",
  DocumentUrl: "",
  lstNomineeUpdate: [],
  POIOption1: "",
  POIOption2: "",
  POIOption3: "",
  Aadhar_number: "",
  Aadhar_Valid_Status: "",
  PAN_number: "",
  Pan_Valid_status: "",
  Address1: "",
  Address2: "",
  Address3: "",
  Area: "",
  City: "",
  Pincode: "",
  State: "",
  Country: "",
  Address_Valid_status: "",
  Address_STP_Flag: "",
  Account_number: "",
  Account_type: "",
  IPFSC_code: "",
  MICRCode: "",
  Bank_name: "",
  Branch_name: "",
  Bank_valid_status: "",
  TransactionId: "",
};

export const LiUpdatePanCaseCreateSampleReqBody: T_CreateCaseRequest = {
  ...LiBaseCaseCreateReqBody,
  CODE: "PNFT009",
  NsdlAPIStatus: "SUCCESS",
  NameAsNsdl: "",
  PolicyOwnerName: "",
  NameMatchPercent: "",
  NameMatchAPIStatus: "",
  NameMatched: "",
  FunctionalityCode: InAppFeatureFuncCodes.LI_UPDATE_PAN,
};

export const LiUpdateEmailCreateSampleReqBody: T_CreateCaseRequest = {
  ...LiBaseCaseCreateReqBody,
  CODE: "PNFT007",
  Bank_IMPS_Status_Code: "",
  HOLD_CIT_OF_O_Country: "",
  Tax_Resi_of_other_country: "",
  country_name: "",
  Tax_iden_number: "",
  ReinstatementAmount: "",
  Medicals: "",
  COI_COVID_Quest: "",
  PXResponse: "",
  COISignedDate: "",
  AnniversaryDate: "",
  MethodChange: "",
  OldFrequency: "",
  NewFrequency: "",
  DynamicLinkGUID: "",
  FunctionalityCode: InAppFeatureFuncCodes.LI_UPDATE_EMAIL,
};

const HlBaseCaseCreateReqBody = {
  customerId: "",
  accountNumber: "",
  firstName: "",
  lastName: "",
  mobile: "",
  emailId: "",
  subject: "",
  source: "ABC_Servicing_App",
  subtype: "",
  comments: "",
  isClosed: true,
  url: "",
  category: "Request",
  lob: "HFC",
  priority: "Low",
  segment: "Finance",
  callbackDate: "",
  callbackTimeSlot: "",
  stpsRequestType: "",
  asOnDate: "",
  salaryCreditDate: "",
  dueDate: "",
  changeInEmiAmount: "",
  payableCharge: "",
  payPaymentAmount: "",
  partPaymentAmount: "",
  impact: "",
  modeOfRepayment: "",
  soaFromDate: "",
  soaToDate: "",
  icFromYear: "",
  icToYear: "",
  attachments: null,
  FunctionalityCode: "",
};

export const HlChangeEmailCaseCreateSampleReqBody = {
  ...HlBaseCaseCreateReqBody,
  NEWEMAILID: "",
  NEWMOBILENUMBER: "",
  modeOfChangeOfAddress: "",
  subject: "Email Update",
  subtype: "hfl023",
  FunctionalityCode: InAppFeatureFuncCodes.HL_UPDATE_EMAIL,
};

export const HlBalanceConfirmCaseCreateSampleReqBody = {
  ...HlBaseCaseCreateReqBody,
  subject: "Statements & Documents-BalanceConfirmationLetter",
  subtype: "hfl005",
  FunctionalityCode:
    InAppFeatureFuncCodes.HL_STATEMENTS_DOCUMENTS_BALANCE_CONFIRMATION_LETTER,
};

export const HlChangeMobileCaseCreateSampleReqBody = {
  ...HlBaseCaseCreateReqBody,
  NEWEMAILID: "",
  NEWMOBILENUMBER: "",
  modeOfChangeOfAddress: "",
  subject: "Mobile number Change",
  subtype: "hfl045",
  FunctionalityCode: InAppFeatureFuncCodes.HL_MOBILE_NUMBER_CHANGE,
};

export const SET_ALERT_MESSAGE =
  "Alert will be sent to your registered Email ID";

export const LiUpdateMobileNumberCreateSampleReqBody: T_CreateCaseRequest = {
  ...LiBaseCaseCreateReqBody,
  CODE: "PNFT008",
  FunctionalityCode: InAppFeatureFuncCodes.LI_UPDATE_MOBILE_NUMBER,
};

export const FAQDisclaimerTitle = "Disclaimer";

export const FAQDisclaimerContent =
  "The answers provided here are for informative purposes and may be subject to change, and ABHFL does not warrant their accuracy, adequacy, appropriacy, completeness or reliability. The User understands that nothing contained here is professional legal, commercial or investment advice, and shall not be binding on ABHFL. The User is advised to make investment decisions after conducting their own diligence and research.";
export const rateUsCmsContentData = <T_CmsRateContentVariables>{
  attributes: {
    title: "FINDING A FRIEND IN OUR APP?",
    subTitle: "Tell us how you're feeling in our company?",
    checkBox:
      "ABCD App team or it's research partners can reach me for suggestions on improving ABCD App experience",
    lowRatingDescription: "OH-OH! TELL US WHAT WENT WRONG",
    highRatingDescription: "Tell us about your experience",
    successTitle: "GOTCHA!",
    successMessage:
      "Thank you for sharing your input. We'll come back better than ever before",
  },
  id: 1,
};

export const LI_Appointee_TAC = [
  "1. As per Insurance Act, 1938, as amended from time to time, the nomination cannot be effected if the Policyholder and the Life Insured are two different persons.",
  "2. All previous nominations shall be automatically cancelled on submission of this form and the nomination last received by the Company shall prevail over all previous nominations.",
  "3. If the nomination is in favour of a minor, an appointee who is a major must be named in this form.",
  "4. The Company expresses no opinion as to the validity of the nomination.",
  "5. Any change in the nomination that is made without the knowledge/consent of the Policyholder shall not be valid.",
];

export const LI_Appointee_Declaration = {
  title: "Declaration: ",
  content:
    "I have understood the meaning and scope of this change request form and take complete responsibility for the change submitted by me herein. I understand that any change in Nominee details is subject to the Policy terms, conditions and relevant underwriting guidelines. I understand that this is only a change request form and that the Company shall not be under any obligation to make the changes proposed herein. I confirm that I have read and understood all the relevant policy provisions and their consequences before making submitting this change request.",
};
export const policyRenewalEncryptionIV = "5891233561234567";
export const policyRenewalEncryptionSecretKey = "5891233561234567";
export const policyRenewalSource = "ABC App";

export const HlExcessEMIRefundCaseCreateSampleReqBody: T_CreateCaseAPIRequest =
  {
    ...HlBaseCaseCreateReqBody,
    customerId: "",
    accountNumber: "",
    firstName: "",
    lastName: "",
    mobile: "",
    emailId: "",
    subject: "Account Related-EMIExcessRelated",
    subtype: "RWRORHFC",
    isClosed: false,
    priority: "LOW",
    attachments: [],
    document: [],
    FunctionalityCode: "",
  };

export const LiAddUpdateBackAccountDetailCaseCreateSampleReqBody: T_CreateCaseRequest =
  {
    ...LiBaseCaseCreateReqBody,
    CODE: "PNFT034",
    REMARKS: "NON_PENNY",
    Account_number: "",
    Account_type: "",
    IPFSC_code: "",
    MICRCode: "000000000",
    Bank_name: "",
    Branch_name: "",
    Bank_valid_status: "",
    PolicyOwnerName: "",
    DynamicLinkGUID: "",
    Bank_Account_Holder_Name: "",
    Bank_IMPS_Verification_Flag: "",
    Bank_IMPS_Date: "",
    Bank_IMPS_Status_Code: "0",
    Bank_IMPS_Reason: "Transaction Successfull",
    BANK_STP_Flag: "",
    MatchPercentage: "1",
    TransactionId: "",
    FunctionalityCode: InAppFeatureFuncCodes.LI_ADD_UPDATE_BANK_ACCOUNT,
  };

export const karzaApiNSTPStatusCode: string[] = [
  "KC02",
  "KC04",
  "KC08",
  "KC09",
  "KC10",
  "KC11",
  "KC13",
  "KC14",
  "KC15",
  "KC17",
  "KC18",
  "KC20",
  "KC22",
  "KC23",
  "KC24",
  "KC26",
  "KC30",
  "KC31",
  "KC32",
  "KC33",
  "KC35",
  "KC36",
  "KC37",
  "KC38",
  "KC39",
  "KC41",
  "KC42",
  "KC43",
  "KC44",
  "KC48",
  "KC56",
];
export const karzaApiSTPStausCode = [
  { stauscode: "KC01", message: "Success message as per current process" },
  {
    stauscode: "KC03",
    message:
      "Invalid Beneficiary Account Number or IFSC. Kindly enter correct details.",
  },
  {
    stauscode: "KC05",
    message:
      "Your Account is Blocked/Frozen. Please retry with Valid/Active bank account details.",
  },
  {
    stauscode: "KC06",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC07",
    message:
      "Your Account is Closed. Kindly retry with Active bank account details.",
  },
  {
    stauscode: "KC12",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC16",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC19",
    message:
      "Invalid Beneficiary Account Number or IFSC. Kindly enter correct details.",
  },
  {
    stauscode: "KC21",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details..",
  },
  {
    stauscode: "KC25",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC27",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC34",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC40",
    message:
      "Invalid Beneficiary IFSC Code or NBIN. Kindly enter correct details.",
  },
  {
    stauscode: "KC45",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC46",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC47",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
];
export const liRedirectionFunctionalityCodes = [
  "P",
  "D",
  "MC",
  "ENACH",
  "LR",
  "LA",
  "FS",
  "ESI",
  "CI",
  "SC",
  "D",
  "CT",
  "ST",
  "EI",
];

export const pageMessages = {
  "update-pan": "PM02",
  "update-mobile": "PM03",
  "update-email-request": "PM05",
  "update-email-success": "PM04",
  "update-email-register": "PM06",
  "update-whatsapp-optout": "PM07",
  "update-whatsapp-optin": "PM08",
  "add-update-bank-account": "PM09",
  "add-update-nominee": "PM10",
  "update-tdsrefund-success": "PM12",
  "excess-emi-refund": "PM11",
  "li-statement-download-flow": "PM12",
  "li-statement-whatsapp-flow": "PM13",
  "li-statement-email-flow": "PM14",
  "li-policy-bond": "PM15",
  "li-pan-aadhar-linking-success": "PM16",
  "li-pan-aadhar-linking-check-status": "PM17",
  "li-pan-aadhar-linking-failure": "PM18",
  "li-re-kyc-confirmation": "PM19",
  "li-re-kyc-success": "PM20",
  "li-re-kyc-eligibility-note": "PM21",
  "li-re-kyc-mandatory-note": "PM22",
  "ga-edit-email-note": "PM23",
  "li-nudge-update-nominee": "PM24",
  "li-nudge-update-bankDetail": "PM25",
  "li-re-kyc-update-address": "PM26",
};
export const otpExpirationCoolOffPeriod: string = "30 minutes";

export const radioListTdsData = [
  { radioLabel: "tdsRefund.options.digital", radioKey: "digitally" }, // Digitally Signed TDS Certificate
  { radioLabel: "tdsRefund.options.manual", radioKey: "manually" }, // Manually Signed TDS Certificate
];

export const userLables = {
  DOB: "DOB in YYYY/MM/DD",
  PAN: "Your PAN",
};

export const Branch_Locator_Url =
  "https://www.adityabirlacapital.com/branch-locator";

export enum HlSuccessMessages {
  VISIT_BRANCH = "HL01",
  CHANGE_ADDRESS = "HL02",
  EXCESS_EMI_REFUND = "HL03",
  TDS_REFUND = "HL04",
  CHANGE_EMI_TENURE = "HL05",
  CHANGE_EMI_DATE = "HL06",
  CHANGE_MOBILE_NUMBER = "HL07",
  CHANGE_EMAIL_ID = "HL08",
  INSURANCE_COPY_EMAIL = "HL09",
  DOCUMENTS_EMAIL = "HL10",
  GST_INVOICE_EMAIL = "HL11",
  BALANCE_CONFIRMATION_DOWNLOAD = "HL12",
  BALANCE_CONFIRMATION_EMAIL = "HL13",
  INSURANCE_COPY_DOWNLOAD = "HL14",
  DOCUMENTS_DOWNLOAD = "HL15",
  GST_INVOICE_DOWNLOAD = "HL16",
  WELCOME_KIT_EMAIL = "HL17",
  WELCOME_KIT_DOWNLOAD = "HL18",
  REPAYMENT_SCHEDULE_EMAIL = "HL19",
  REPAYMENT_SCHEDULE_DOWNLOAD = "HL20",
  NO_DUES_CERTIFICATE_DOWNLOAD = "HL21",
  NO_DUES_CERTIFICATE_EMAIL = "HL22",
  PROCESSING_FEES_REFUND = "HL23",
}

export enum ErrorMessageCodes {
  // Only alphanumeric characters and , . / - ( ) & are permitted
  HI_ALLOWED_CHAR = "CS_HI_VAL_MS_200",

  // Re send OTP allowed to use for three times only for the session
  GA_3OTP = "CS_GA_3OTP_MS_200",

  // Please retry after 30 mins
  GA_ROTP = "CS_GA_ROTP_MS_200",

  // Incorrect OTP, please try again later
  GA_IOTP = "CS_GA_IOTP_MS_200",

  // Please enter valid PAN
  GA_VPAN = "CS_GA_VPAN_MS_200",

  // Please enter a valid mobile number
  GA_VMNO = "CS_GA_VMNO_MS_200",

  // Re send OTP allowed to use for three times only for the session
  LI_ROTP = "CS_LI_ROTP_MS_200",

  // Entry of three OTP wrong shall be allowed
  LI_3OTP = "CS_LI_3OTP_MS_200",

  // Incorrect OTP, please try again
  LI_IOTP = "CS_LI_IOTP_MS_200",

  // Please enter a valid Email ID
  LI_VEID = "CS_LI_VEID_MS_200",

  // Request submitted recently. You can submit new request after 30 min
  LI_RRU = "CS_LI_RRU_MS_200",
}
export const otpScreenErrorMsg =
  "You have reached the maximum attempt of tries. Please try again after 30 minutes.";

export const changeEmiDateDelinquencyStatusList: string[] = [
  "sma-1",
  "sma-0",
  "doubtfull2",
  "substandar",
  "doubtfull1",
  "doubtfull3",
  "sma-2",
  "sma 0",
];

export const functionalityCodeForGenerateOtpApi: string = "LGN_OTP";
export const fcForEmailUpdateGenerateOtpApi: string = "MAIL_UPDATE_OTP";

export const serviceRequestsStatusForActiveTab: string[] = [
  "new",
  "open",
  "in progress",
  "waiting for customer",
];
export const serviceRequestsStatusForResolvedTab: string[] = [
  "resolved",
  "closed duplicate",
  "unresolved",
];
export const loginOnboardingPageContent: string =
  "Welcome to Aditya Birla Capital, your trusted partner in financial growth. Our service platform offers a seamless experience, enabling you to manage investments, insurance, and loans effortlessly. Managing your finances has never been more convenient. Log in & take control of your finances with confidence.";
export const carouselScreenTypeData = {
  mobileCarousel: {
    menuId: 171,
    menuName: "Mobile Carousal Screen",
  },
  webCarousel: {
    menuId: 160,
    menuName: "Web Carousal Screen",
  },
};

export const pocketInsuranceCmsType = "Pocket-Insurance";
export const travelInsuranceCmsType = "Travel-Insurance";
export const pocketProductCategory = "Pocket Insurance";
export const travelProductCategory = "Travel Insurance";
export const centerBanner = "center-banner";
export const ticker = "Ticker";
export const NoHoldingFetched = "HoldingNotFetched";
export const taxCenterCmsType = "Tax-Center";
export const getInsuranceFunctionalityCode: any = {
  "Pocket-Insurance": "PI",
  "Travel-Insurance": "TI",
};

export const serviceMob = "ServiceMob";
export const serviceWeb = "ServiceWeb";
export const serviceApp = "ServiceApp";
export const ABCDService = "ABCDService";

export const platformWeb = "web";
export const platformMobile = "mobile";
export const platformSuperApp = "super app";

//HFL Change Address Constant
export const changeAddressYesSubTypeValue = "hfl003";
export const changeAddressNoSubTypeValue: string = "AC123456";
export const changeAddressYesMode = "VKYC";
export const changeAddressNoMode = "FI";
export const changeAddressLob = "HFC";
export const changeAddressYesCategory = "Request";
export const changeAddressNoCategory = "Query";

//HFL Interest Certificate Constant
export const interestCertificateMenuName: string = "Interest Certification";
export const hiInforcePolicyStatus: string = "IF";
export const hiExpiredPolicyStatus: string = "EXPIRED";

//ABCD Holdings Constant
export const digiGoldTitle = "Digital gold";
export const digiGoldLiveText = "Gold";
export const digiSilverTitle = "Digital silver";
export const digiSilverLiveText = "Silver";
export const fixedDepositsTitle = "Fixed deposits";
export const pocketInsuranceTitle = "Pocket Insurance";
export const travelInsuranceTitle = "Travel Insurance";
export const motorInsuranceTitle = "Motor Insurance";
export const buyMoreWithABCDText = "Buy more with ABCD";
export const viewMoreDetailsOnAbcd = "View more details on ABCD";
export const recentTransactionsText = "Recent transactions";
export const downloadInsuranceCertificateText =
  "Download Insurance Certificate";
export const viewAllText = "View All";
export const claimProcessText = "Claim Process";
export const productCodes = {
  digiGold: "DG",
  digiSilver: "DS",
  fixedDeposit: "deposit",
  pocketInsurance: "PI",
  travelInsurance: "TI",
  motorInsurance: "MI",
};
export const transactionTypes = {
  sell: "SELL",
  redeem: "REDEEM",
  buy: "BUY",
  transfer: "TRANSFER",
};

export const transactionStatus = {
  confirmed: "Confirmed",
  success: "Success",
  failed: "Failed",
  inProgress: "In Progress",
  reversed: "Reversed",
  transferred: "Transferred",
};
export const transactionApiStatus = {
  successful: "successful",
  failed: "failed",
  failure: "failure",
  inProgress: "in progress",
  reversed: "reversed",
  transferred: "transferred",
};
export const recentTransactionsMaxLength = 5;
export const abcdFunctionalityCodes = {
  digiGold: "D",
  digiSilver: "D",
  fixedDeposit: "D",
  pocketInsurance: "PI",
  travelInsurance: "TI",
  motorInsurance: "MI",
};

export const centerBannerFunctionalityCodes = "CB";
export const motorInsuranceProductTypes = {
  car: "car",
  bike: "bike",
};

export const motorInsurerNames = {
  iciciLombard: "icici lombard",
  acko: "acko",
  digit: "digit",
};
export const mobileNumberForUserProductStatusApi = "9080529856";
export const motorInsuranceCertificateName = "Motor_Insurance_Certifcate";
export const errorPopupBodyTitle = "Document is unavailable";
export const errorPopupBodyBtnLabel = "Connect to customer support";
export const travelInsuranceCertificateName = "Travel_Insurance_Certifcate";
export const pocketInsuranceCertificateName = "Pocket_Insurance_Certifcate";
export const motorInsurancePolicyTypeViewPoint = 430;
//ABCD Holdings Constant end here

export let onUserLoginCleverTapStatic: T_OnUserLoginCleverTapStatic = {
  Name: "",
  Identity: "",
  Email: "",
  Phone: "",
  Gender: undefined,
  DOB: "",
  "MSG-email": false,
  "MSG-push": false,
  "MSG-sms": false,
  "MSG-whatsapp": false,
  Stuff: "",
};

export const statusCode = 404;

//Callus popup constants
export const callUsTitle = "CALL US";
export const callUsSubTitle =
  "For help and support, please reach us at this number:";
export const callUsContact = "18002707000";
export const callUsTimings = "Mon–Sun, 9:00 AM – 9:00 PM";
export const createCaseIsCloseIsTrue = "true";
export const createCaseIsCloseIsFalse = "false";

//Purchase CTA constants start here
export const staticPurchaseCtaName = "Explore";
export const staticPurchaseCtaRedirectionUrl =
  "https://adityabirlacapitaldigital.onelink.me/vYLv/a2efnsv7";
export const purchaseCtaMenuName = "Purchase CTA";
//Purchase CTA constants end here

//OSP-1232 related constants start here
export const sfdcSourceName = "ABC_Servicing_App";
export const sfdcIntimationType = "Endorsement";
export const sfdcPriority = "Medium";
export const sfdcChannel = "Digital";
export const sfdcBusinessUnit = "ABHI";
export const sfdcEndorsmentMasterKeys = {
  updateEmailId: "update email id",
  updatePrimaryNumber: "update primary number",
  updateAddress: "communication address change",
  updateNomineeDetails: "nominee modification",
  updateDOB: "dob correction",
  updateGender: "gender correction",
  updateName: "name correction",
  updatePAN: "pan update",
  updateAlternateNumber: "update alternate number",
};
//OSP-1232 related constants end here

export const unifiedBannerType = "Unified Banner";
// export const unifiedBannerType_Top = "Unified Banner_Top";
export const topUnifiedBanner = "Top_Unified Banner";
export const centerUnifiedBanner = "Center_Unified Banner";
export const footerUnifiedBanner = "Footer_Unified Banner";
export const promotionalCardType = "Promotional Banner";
export const nudgeType = "Nudge";
export const buyNewProductType = "Buy New Product";
export const trackWhatMatter = "Track What Matters";
export const purchaseCTAType = "Explore ABCD";
export const downloadDocumentCode = "DD";

export const topBannerName = "Top Banner";
export const centerBannerName = "Center Banner";
export const footerBannerName = "Footer Banner";
export const nudgeBannerName = "Nudge Banner";
export const l2BannerName = "L2 Banner";
export const newOfferingName = "New Offerings";
export const myTrackName = "My Track";

//OSP-1592 related constant start here
export const staticTitleText = "FEEDBACK PLEASE";
export const subTitleMainText =
  "Please rate your experience based on your recent interaction, with ";
export const subTitleSpanText = "10 being the highest and 0 being the lowest.";
export const staticTextBoxValue =
  "Please share any additional details that could help us improve.";
//OSP-1592 related constant end here

export const nameRegex =
  /^[A-Za-z][A-Za-z'’.-]*(?: [A-Za-z'’.-]+)*(?: [A-Za-z'’.-]+)?$/;
export const validNameCharacterRegex = /^[A-Za-z\-\.'’ ]/;
export const validEmailCharacterRegex = /^[a-zA-Z0-9._@-]+$/;

//OSP-1402 related constant end here
export const homePageRouteL1 = "/home";
export const DetailPageRouteL2 = "/details";
export const DetailPageStockRouteL2 = "/my-portfolio";
export const DetailPageMutualFundRouteL2 = "/mutual-fund";

export const LiCheckPanAadharLinkingCtaName = "Check PAN Aadhar Linking Status";

export const pathToLobCodeMap = {
  "/details/li": "02",
  "/details/hi": "06",
  "/mutual-fund": "01",
  "/my-portfolio": "24",
  "/details/hl": "04",
} as const;

export const pathToModuleName = {
  "/details/li": "Life Insurance",
  "/details/hi": "Helath Insurance",
  "/mutual-fund": "Mutual Fund",
  "/my-portfolio": "Stocks",
  "/details/hl": "Home Loan",
  "/home": "Dashboard",
} as const;

export type ModuleNameKey = keyof typeof pathToModuleName;
export type PathKey = keyof typeof pathToLobCodeMap;
export const ActiveStatusText = "ACTIVE";

//OSP-2212 constants start here
export const myStatementsText = "My Statements";
export const capitalGainSubMenuName = "Capital Gain Statement";
export const capitalGainFunctionalityKey = "CAPITAL_GAIN_STATEMENT";
export const capitalGainModeText = "CGS";
export const capitalGainModuleName = "Mutual Fund Capital Gain Statement";
export const exitLoadSubMenuName = "Exit Load";
export const exitLoadFunctionalityKey = "EXIT_LOAD_STATEMENT";
export const exitLoadModeText = "ELS";
export const exitLoadModuleName = "Mutual Fund Exit Load Statement";
export const accountStatementSubMenuName = "Account Statement";
export const accountStatementFunctionalityKey = "ACCOUNT_STATEMENT";
export const accountStatementModeText = "AS";
export const accountStatementModuleName = "Mutual Fund Account Statement";
//OSP-2212 constants end here

//OSP-2482 constants start here
export const extendedFeedbackPopupTitle = "YOUR OPINION MATTER TO US";
export const extendedFeedbackPopupSubTitle =
  "If you enjoy using ABCD app, would you mind rating us on the App store?";
export const extendedFeedbackPopupCtaText = "Rate Us";
//OSP-2482 constants end here

//OSP-3117 constants start here
export const onBoardingBannerTitle =
  "Verify your profile with PAN or date of birth to view holdings";
export const onBoardingBannerCtaText = "Verify profile";
export const downloadTheAppSectionTitle =
  "Explore all ABC product offerings on the go";
export const downloadTheAppSectionSubTitle = " Download the app";
export const downloadTheAppSectionCtaText = "Download now";
export const trackWhatMattersQrCodePopupTitle = "Track What Matters to you";
export const exploreAbcOfferingsQrCodePopupTitle = "ABC Product Offerings";
export const exclusiveAbcOffersQrCodePopupTitle = "ABC Exclusive Offers";
export const bannersQrCodePopupTitle = "Promotional Banners";
//OSP-3177 constants end here

export const POLICY_INDICATOR_VALUE = ["GENERAL", "HUF"];

//OSP-4315 constants start here
export const tollFreeTitle = "Toll Free Number";
export const tollFreeNumber = "1800 270 7000";
export const contactUsEmail = "care.adityabirlacapital.com";
export const contactUsTimings = "Mon - Sun, 9.00 AM - 9.00 PM";
//OSP-4315 constants start here

//OSP-3751 constants start here
export const inValidPanHelperText = "Please enter a valid PAN";
export const invalidDOBHelperText = "Please enter a valid DOB";
export const invalidDOBValidationHelperText =
  "Date of birth entered does not match our records, please try again.";
export const invalidPANValidationHelperText =
  "PAN entered does not match our records, please retry.";
//OSP-3751 constants end here

//OSP-4415 constants start here
export const invalidEmailHelperText = "Please enter valid EMAIL";
export const customEmailRegex =
  /^(?!.*\.\.)(?!\.)(?!.*\.$)(?!.*\.-)(?!.*-\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9]){1,})+$/;
//OSP-4415 constant end here

//OSP-4640 constants start here
export const nomineeNudgeDescription = "update nominee nudge";
export const nomineeNudgeUpdateCtaDescription = "update nominee cta clicked";
export const nomineeNudgeFunctionalityCode = "02NGNOM";
export const nomineeNudgeUpdateCtaFunctionalityCode = "02NGNOM_CTA";
export const bankAccountNudgeDescription = "update bank account";
export const bankAccountNudgeUpdateCtaDescription = "update bank cta clicked";
export const bankAccountNudgeFunctionalityCode = "02NGBNK";
export const bankAccountNudgeUpdateCtaFunctionalityCode = "02NGBNK_CTA";
//OSP-4640 constants end here

//OSP-4177 constants start here
export const tickerSpeed = 2;
//OSP-4177 constants end here

export const priorityBanner2Type = "Priority Banner 2";

//OSP-5559 constants start here
export const ABCChannelSource = {
  "150": "ABC_Mobile_CS",
  "151": "ABC_Web_CS",
  "152": "ABC_PWA_Web_CS",
  "153": "ABC_PWA_Mobile_CS",
  "155": "ABC_Mobile_Web_CS",
};
//OSP-5559 constants end here

//OSP-6381 constants start here
export const recentUpdatesErrorMessageSplit =
  "Request submitted recently. You can submit new request after";
export const recentUpdatesFallBackErrorMessage =
  "Request submitted recently. You can submit new request after 24 hrs";
//OSP-6381 contants end here

//OSP-6043 constants start here
export const blockedUserDefaultMessage =
  "Due to security reasons, your ABC Service platform login has been blocked. Please contact our customer care on 18002707000 for further details.";
export const blockedUserDefaultTitleMessage = "Customer is blocked!";
//OSP-6043 constants end here

export const mfCapitalGainStatementBaseRequest = {
  PAN: null,
  FolioNo: "",
  SchemeCode: null,
  StatementTenure: "",
  FromDate: "",
  ToDate: "",
  Type: "PDF",
  UserId: "MFWebApp",
  Password: "cGFzc0AxMjM=",
  Source: null,
  UDP: null,
  IFACode: null,
  EUINCode: null,
  FilterFor: null,
  SessionId: null,
  ClientIpAddress: null,
  OS: null,
  IMEI: null,
  UDP1: null,
  UDP2: null,
  UDP3: null,
  UDP4: null,
  UDP5: null,
  Channel: null,
  PageURL: null,
  Campaign: null,
  Trans_No: null,
  TransactionType: null,
  ServerIpAddress: null,
  ModuleName: null,
  MethodName: null,
  AuthCode: null,
  GoogleAdID: null,
  DeviceId: null,
  UserName: null,
  UDP6: null,
  UDP7: null,
  AdditionalUdp: null,
};

export const mfAccountStatementBaseRequest = {
  ArnCode: "",
  RecipientType: "I",
  FolioNumber: "",
  Pan: "",
  SoaType: "",
  SoaOption: "",
  SoaFormat: "",
  FromDate: "",
  ToDate: "",
  UserId: "MFWebApp",
  Password: "cGFzc0AxMjM=",
};
//OSP-6445 constants start here
export const standardDateFormat = "DD-MM-YYYY";
export const standardDateFormatForCapitalGain = "DD-MMM-YYYY";
export const sendEmailDocApiSuccessMessage = " Email Sent successfully";
export const sendEmailDocApiFailureMessage =
  "Currently we are facing some technical issues in sending the document on mail, please try after some time";
export const abcdHoldingsEmailInsuranceBtnText = "Email Insurance Certificate";
//OSP-6445 constants start here

//OSP-6654 constants start here
export const serviceRequestDateFormat = "MMMM Do, YYYY";
//OSP-6654 constants end here

//SAS-1791 constants start here
export const defaultCiiNoForABFL = "12345678";
//SAS-1791 constants end here

//Error Variables start here
export const technicalErrorPopupTitle = "Technical Failure";
export const technicalErrorPopupSubTitle =
  "Apologies! We are encountering technical challenges in fulfilling your request. Please try again after sometime.";

//Error Variables end here

export const errorResponse = {
  code: 0,
  message: "Failure",
  uiDisplayMessage: "Failure",
  uiDisplayTitle: "Failure",
};

export const defaultPopularServicesLobList = [
  "Mutual Funds",
  "Stocks & Securities",
  "Life Insurance",
  "Health Insurance",
  "Home Loans",
  "Personal Loans/Credit Card",
];

export const homeLoanHomePageSource: "homeLoanHomePage" = "homeLoanHomePage";
export const homeLoanDetailsSource: "homeLoanDetails" = "homeLoanDetails";
export const mutualFundDetailsSource: "mutualFundDetails" = "mutualFundDetails";
export const healthInsuranceDetailsSource: "healthInsuranceDetails" =
  "healthInsuranceDetails";
export const lifeInsuranceDetailsSource: "lifeInsuranceDetails" =
  "lifeInsuranceDetails";

export const homeLoanReKycServiceReqSubjectList = [
  "rekyc no change",
  "rekyc address change, vkc - no",
  "rekyc address change request",
];

export const maskedCurrencyValue = "₹ --.--";
export const maskedPercentageValue = "--.--%";
